<template>
  <div class="gfr-menu-view">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.gfr-menu-view {
  @apply before:absolute before:-top-8 before:left-0 before:z-10 before:h-8 before:w-full before:bg-transparent before:content-[''];
}
</style>
